import { logEvent } from 'firebase/analytics'

import { analytics } from '@/firebase'
import { type CardActivityType } from '@/models/card-activity/card-activity.model'

export const logOpenBulkImport = (data = {}) => {
  logEvent(analytics, 'open_bulk_import', data)
}

export const logCloseBulkImport = (data = {}) => {
  logEvent(analytics, 'close_bulk_import', data)
}

export const logImportCardsSuccess = (data: { cardType: CardActivityType; numberOfCards: number }) => {
  logEvent(analytics, 'import_cards_success', data)
}

export const logImportCardsFail = (data: { cardType: CardActivityType; numberOfCards: number }) => {
  logEvent(analytics, 'import_cards_fail', data)
}

export const logCreateBulkImportCardsSuccess = (data: { cardType: CardActivityType; numberOfCards: number }) => {
  logEvent(analytics, 'create_bulk_import_cards_success', data)
}

export const logCreateBulkImportCardsFail = (data: { cardType: CardActivityType; numberOfCards: number }) => {
  logEvent(analytics, 'create_bulk_import_cards_fail', data)
}

export const logGenerateCriteriaWithAiSuccess = (data: { numberOfCards: number }) => {
  logEvent(analytics, 'generate_criteria_with_ai_success', data)
}

export const logGenerateCriteriaWithAiFail = (data: { numberOfCards: number }) => {
  logEvent(analytics, 'generate_criteria_with_ai_fail', data)
}

export const logGenerateTranslationsSuccess = (data: { numberOfCards: number }) => {
  logEvent(analytics, 'generate_translations_success', data)
}

export const logGenerateTranslationsFail = (data: { numberOfCards: number }) => {
  logEvent(analytics, 'generate_translations_fail', data)
}

export const logGenerateAnswersSuccess = (data: { numberOfCards: number }) => {
  logEvent(analytics, 'generate_answers_success', data)
}

export const logGenerateAnswersFail = (data: { numberOfCards: number }) => {
  logEvent(analytics, 'generate_answers_fail', data)
}

export const logGenerateCorrectAnswersSuccess = (data: { numberOfCards: number }) => {
  logEvent(analytics, 'generate_correct_answers_success', data)
}

export const logGenerateCorrectAnswersFail = (data: { numberOfCards: number }) => {
  logEvent(analytics, 'generate_correct_answers_fail', data)
}
